"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Hubspot = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#FF7A59",
        d: "M17.564 8.685V6.143a1.958 1.958 0 001.129-1.764v-.058c0-1.08-.876-1.957-1.957-1.957h-.059c-1.08 0-1.957.876-1.957 1.957v.058a1.958 1.958 0 001.129 1.764v2.542a5.543 5.543 0 00-2.636 1.16l-6.97-5.429c.05-.18.076-.364.079-.55a2.205 2.205 0 10-2.208 2.202A2.181 2.181 0 005.2 5.772l6.864 5.341a5.56 5.56 0 00.085 6.262l-2.088 2.088a1.795 1.795 0 00-.522-.085 1.81 1.81 0 101.813 1.813 1.79 1.79 0 00-.085-.522l2.065-2.066a5.57 5.57 0 104.232-9.918zm-.855 8.359a2.857 2.857 0 110-5.713 2.857 2.857 0 01.002 5.711"
      }
    )
  );
};
export default Hubspot;
